'use client';

import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useAtom } from 'jotai';
import { useSearchParams } from 'next/navigation';
import { overwrittenPromoConfigAtom } from '@/atoms/promoAtom';
import { Locale } from '@/utility/locale';
import { getActivePromoName, isPromoExired, setActivePromoName } from '@/utility/promos';
import { getPromoBannerQueryOptionsClient } from './QueryOptions/promoQueryOptionsClient';
export const PromoBannerData = t0 => {
  const $ = _c(11);
  const {
    locale
  } = t0;
  const searchParams = useSearchParams();
  const [overwrittenPromoConfig, setOverwrittenPromoConfig] = useAtom(overwrittenPromoConfigAtom);
  let t1;
  if ($[0] !== searchParams) {
    t1 = searchParams.get("promo") ?? getActivePromoName();
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const customPromoKey = t1;
  const t2 = customPromoKey ? `promo-${customPromoKey}` : null;
  let t3;
  if ($[2] !== locale || $[3] !== t2) {
    t3 = getPromoBannerQueryOptionsClient(t2, locale);
    $[2] = locale;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    data: promoBannerData
  } = useQuery(t3);
  let t4;
  let t5;
  if ($[5] !== customPromoKey || $[6] !== overwrittenPromoConfig || $[7] !== promoBannerData || $[8] !== setOverwrittenPromoConfig) {
    t4 = () => {
      if (promoBannerData && !isPromoExired(promoBannerData) && !overwrittenPromoConfig && customPromoKey) {
        setOverwrittenPromoConfig(promoBannerData);
        setActivePromoName(customPromoKey, promoBannerData.content._meta.lifecycle ? new Date(promoBannerData.content._meta.lifecycle?.expiryTime) : null);
      }
    };
    t5 = [customPromoKey, overwrittenPromoConfig, promoBannerData, setOverwrittenPromoConfig];
    $[5] = customPromoKey;
    $[6] = overwrittenPromoConfig;
    $[7] = promoBannerData;
    $[8] = setOverwrittenPromoConfig;
    $[9] = t4;
    $[10] = t5;
  } else {
    t4 = $[9];
    t5 = $[10];
  }
  useEffect(t4, t5);
  return null;
};